module.exports = __webpack_public_path__ + "static/media/clc_guide.0705fff8.mp4";